import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import * as globalConst from './../../../constants';
import { Subject } from "rxjs/Rx";

@Injectable()
export class LoginService {

	private apiUrl = globalConst.baseAPI;  // URL para web api
	public permissionsLoaded = new Subject<boolean>();

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	login(data: any) {
		return this.http.post(this.apiUrl + "V1/token", data).map((res: Response) => res.json());
	}

	getUserInfo(token) {
		return this.http
			.get(this.apiUrl + "users/v1/getcoduseractive", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getPermissons(token) {
		return this.http
			.get(this.apiUrl + "users/v1/permissions", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	changeCompany(token, userID, userName, companyID) {

		var data = {
			EmpresaLogada: companyID,
			Nome: userName,
			ID: userID
		}

		return this.http
			.put(this.apiUrl + "users/v1/updateuserpreferences/", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/login/service/login.service.ts